export default {"src":"/_next/static/media/close-favorite.045f5553.svg","height":17,"width":17};